import { defineMessages } from '@kyruus/intl';

export default defineMessages({
  globalAvailOffLabelText: {
    id: 'global_availability.controls.off.header',
    description:
      'Label text for the availability controls when they are in the OFF state',
    defaultMessage: 'View Available Appointment Times'
  },
  globalAvailOnLabelText: {
    id: 'global_availability.controls.on.header',
    description:
      'Label text for the availability controls when they are in the ON state',
    defaultMessage: 'Appointment Times for:'
  },
  globalAvailApptTypeButton: {
    id: 'button.global_availability.show',
    description:
      'Text content for the button used to enable the availability controls',
    defaultMessage: 'Select Appointment Type'
  },
  globalAvailEditButton: {
    id: 'button.global_availability.edit',
    description:
      'Text content for the button used to edit the appointment type selection in the availability controls',
    defaultMessage: 'Edit'
  },
  globalAvailClearButton: {
    id: 'button.global_availability.hide',
    description:
      'Text content for the button used to clear the appointment type selection in the availability controls',
    defaultMessage: 'Clear'
  },
  gloabalAvailApptTypeButtonAriaLabel: {
    id: 'button.global_availability.show_aria_label',
    description:
      'Aria label for the button used to enable the availability controls',
    defaultMessage: 'Select appointment type'
  },
  globalAvailEditButtonAriaLabel: {
    id: 'button.global_availability.edit_aria_label',
    description:
      'Aria label for the button used to edit the appointment type selection in the availability controls',
    defaultMessage: 'Edit your appointment type selection'
  },
  globalAvailClearButtonAriaLabel: {
    id: 'button.global_availability.hide_aria_label',
    description:
      'Aria label for the button used to clear the appointment type selection in the availability controls',
    defaultMessage: 'Clear your appointment type selection'
  },
  patientRelBtnTextEstablished: {
    id: 'global_availability.controls.patient_rel.established',
    defaultMessage: 'Your Current Doctor',
    description:
      'Text to display in the chip rendered when a patient has toggled on availabilities for providers with whom they have an ESTABLISHED relationship'
  },
  patientRelBtnTextNew: {
    id: 'global_availability.controls.patient_rel.new',
    defaultMessage: 'A New Provider',
    description:
      'Text to display in the chip rendered when a patient has toggled on availabilities for providers with whom they will have a NEW relationship'
  }
});
